export const performanceIndicatorData = [
  {
    Designation: "Web Designer",
    Department: "Designing",
    Image: "user-34.jpg",
    ApprovedBy: "Doglas Martini",
    Role: "Manager",
    CreatedDate: "14 Jan 2024",
    Status: "Active",
    key: "1",
  },
  {
    Designation: "Web Developer",
    Department: "Developer",
    Image: "user-34.jpg",
    ApprovedBy: "Doglas Martini",
    Role: "Manager",
    CreatedDate: "21 Jan 2024",
    Status: "Active",
    key: "2",
  },
  {
    Designation: "IOS Developer",
    Department: "Developer",
    Image: "user-34.jpg",
    ApprovedBy: "Doglas Martini",
    Role: "Manager",
    CreatedDate: "18 Feb 2024",
    Status: "Active",
    key: "3",
  },
  {
    Designation: "Android Developer",
    Department: "Developer",
    Image: "user-34.jpg",
    ApprovedBy: "Doglas Martini",
    Role: "Manager",
    CreatedDate: "24 Feb 2024",
    Status: "Active",
    key: "4",
  },
  {
    Designation: "DevOps Engineer",
    Department: "DevOps",
    Image: "user-34.jpg",
    ApprovedBy: "Doglas Martini",
    Role: "Manager",
    CreatedDate: "11 Mar 2024",
    Status: "Active",
    key: "5",
  },
];
